module.exports = __webpack_public_path__ + "static/media/shop-img-1.ffe034f6.png";